import { Link } from 'react-router-dom'
import { SEOTags } from '@/components/SEOTags'
import BlogLayout from '@/components/BlogLayout'
import { posts } from '@/content/blog/postRegistry'

export default function BlogIndexPage() {
  const schema = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: 'Steadfast HSA Blog',
    description: 'HSA strategy, tax optimization, and long-term wealth building for health savings account power users.',
    url: 'https://steadfasthsa.com/blog',
    publisher: {
      '@type': 'Organization',
      name: 'Steadfast HSA',
      url: 'https://steadfasthsa.com',
    },
  })

  return (
    <BlogLayout>
      <SEOTags
        title="Blog | Steadfast HSA"
        description="HSA strategy, tax optimization, and long-term wealth building for health savings account power users."
        url="https://steadfasthsa.com/blog"
        schema={schema}
      />

      <div className="mb-10">
        <h1 className="text-4xl font-extrabold text-[#1B365D] mb-3">Blog</h1>
        <p className="text-slate-500 text-lg">HSA strategy for the long game.</p>
      </div>

      <div className="grid gap-6">
        {posts.map((post) => (
          <Link
            key={post.slug}
            to={`/blog/${post.slug}`}
            className="group block bg-white rounded-xl border border-gray-200 p-6 hover:border-[#1B365D] transition"
          >
            <div className="flex items-center gap-2 text-xs text-slate-400 mb-2">
              <time dateTime={post.date}>
                {new Date(post.date).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })}
              </time>
              <span>·</span>
              <span>{post.readingTime} min read</span>
            </div>
            <h2 className="text-xl font-bold text-[#1B365D] group-hover:underline mb-2">
              {post.title}
            </h2>
            <p className="text-slate-600 text-sm mb-4">{post.description}</p>
            <div className="flex flex-wrap gap-2">
              {post.tags.map((tag) => (
                <span
                  key={tag}
                  className="rounded-full bg-[#f0f4f8] px-3 py-1 text-xs text-[#1B365D] font-medium"
                >
                  {tag}
                </span>
              ))}
            </div>
          </Link>
        ))}
      </div>
    </BlogLayout>
  )
}
